import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toolTipType' })
export class ToolTipTypePipe implements PipeTransform {
    transform(value: string, productTypeCode: string): any {
        if (value && productTypeCode && /LBNONE/i.test(value) && this.isFixed(productTypeCode)) {
            value = 'LBNONEFixed';
        }
        return value;
    }

    isFixed(pCode: string): any {
        let fixedContracts = ['UA', 'UN', '49', 'FL9', 'GA', 'DC1', 'X', 'F0', 'FQ', 'F1', 'FVA', 'YA',
            'YN', 'E1', 'EV', 'FXR', 'FD', 'C', 'FD3', 'GRA', 'F', 'FL2', 'GMA', 'MV1',
            'PF2', 'PF1', 'PR', 'R', 'SG4', 'FL1', 'MVA'];
        return fixedContracts.indexOf(pCode) > -1;
    }
}
